export const imports = {
  'packages/modules/docs/conditional.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-docs-conditional" */ 'packages/modules/docs/conditional.mdx'
    ),
  'packages/modules/docs/root.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-docs-root" */ 'packages/modules/docs/root.mdx'
    ),
  'packages/modules/docs/transform.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-docs-transform" */ 'packages/modules/docs/transform.mdx'
    ),
  'packages/uikit/docs/colors.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-uikit-docs-colors" */ 'packages/uikit/docs/colors.mdx'
    ),
  'packages/uikit/docs/typography.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-uikit-docs-typography" */ 'packages/uikit/docs/typography.mdx'
    ),
  'packages/components/src/components/inputs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-inputs" */ 'packages/components/src/components/inputs.mdx'
    ),
  'packages/components/src/components/Autocomplete/AutocompleteInput.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-autocomplete-autocomplete-input" */ 'packages/components/src/components/Autocomplete/AutocompleteInput.mdx'
    ),
  'packages/components/src/components/Checkbox/Checkbox.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-checkbox-checkbox" */ 'packages/components/src/components/Checkbox/Checkbox.mdx'
    ),
  'packages/components/src/components/ClipboardButton/ClipboardButton.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-clipboard-button-clipboard-button" */ 'packages/components/src/components/ClipboardButton/ClipboardButton.mdx'
    ),
  'packages/components/src/components/Collapsable/Collapsable.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-collapsable-collapsable" */ 'packages/components/src/components/Collapsable/Collapsable.mdx'
    ),
  'packages/components/src/components/DateInput/DateInput.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-date-input-date-input" */ 'packages/components/src/components/DateInput/DateInput.mdx'
    ),
  'packages/components/src/components/DateTime/DateTimeInput.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-date-time-date-time-input" */ 'packages/components/src/components/DateTime/DateTimeInput.mdx'
    ),
  'packages/components/src/components/Dialog/Dialog.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-dialog-dialog" */ 'packages/components/src/components/Dialog/Dialog.mdx'
    ),
  'packages/components/src/components/Drawer/Drawer.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-drawer-drawer" */ 'packages/components/src/components/Drawer/Drawer.mdx'
    ),
  'packages/components/src/components/Button/Button.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-button-button" */ 'packages/components/src/components/Button/Button.mdx'
    ),
  'packages/components/src/components/Dropdown/Dropdown.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-dropdown-dropdown" */ 'packages/components/src/components/Dropdown/Dropdown.mdx'
    ),
  'packages/components/src/components/DropdownDate/DropdownDate.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-dropdown-date-dropdown-date" */ 'packages/components/src/components/DropdownDate/DropdownDate.mdx'
    ),
  'packages/components/src/components/Progress/Progress.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-progress-progress" */ 'packages/components/src/components/Progress/Progress.mdx'
    ),
  'packages/components/src/components/Slider/Slider.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-slider-slider" */ 'packages/components/src/components/Slider/Slider.mdx'
    ),
  'packages/components/src/components/Switch/Switch.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-switch-switch" */ 'packages/components/src/components/Switch/Switch.mdx'
    ),
  'packages/components/src/components/Tabs/Tabs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-tabs-tabs" */ 'packages/components/src/components/Tabs/Tabs.mdx'
    ),
  'packages/components/src/components/Tooltip/Tooltip.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-tooltip-tooltip" */ 'packages/components/src/components/Tooltip/Tooltip.mdx'
    ),
  'packages/components/src/components/Input/Input.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-input-input" */ 'packages/components/src/components/Input/Input.mdx'
    ),
  'packages/modules/src/modules/Agreement/Agreement.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-agreement-agreement" */ 'packages/modules/src/modules/Agreement/Agreement.mdx'
    ),
  'packages/modules/src/modules/Audio/Audio.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-audio-audio" */ 'packages/modules/src/modules/Audio/Audio.mdx'
    ),
  'packages/modules/src/modules/Checkbox/Checbox.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-checkbox-checbox" */ 'packages/modules/src/modules/Checkbox/Checbox.mdx'
    ),
  'packages/modules/src/modules/ClipboardText/ClipboardText.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-clipboard-text-clipboard-text" */ 'packages/modules/src/modules/ClipboardText/ClipboardText.mdx'
    ),
  'packages/modules/src/modules/Collapsable/Collapsable.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-collapsable-collapsable" */ 'packages/modules/src/modules/Collapsable/Collapsable.mdx'
    ),
  'packages/modules/src/modules/Dropdown/Dropdown.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-dropdown-dropdown" */ 'packages/modules/src/modules/Dropdown/Dropdown.mdx'
    ),
  'packages/modules/src/modules/FlexContainer/FlexContainer.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-flex-container-flex-container" */ 'packages/modules/src/modules/FlexContainer/FlexContainer.mdx'
    ),
  'packages/modules/src/modules/Iframe/Iframe.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-iframe-iframe" */ 'packages/modules/src/modules/Iframe/Iframe.mdx'
    ),
  'packages/modules/src/modules/Image/Image.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-image-image" */ 'packages/modules/src/modules/Image/Image.mdx'
    ),
  'packages/modules/src/modules/ImageTiles/ImageTiles.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-image-tiles-image-tiles" */ 'packages/modules/src/modules/ImageTiles/ImageTiles.mdx'
    ),
  'packages/modules/src/modules/Input/Input.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-input-input" */ 'packages/modules/src/modules/Input/Input.mdx'
    ),
  'packages/modules/src/modules/Instructions/Instructions.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-instructions-instructions" */ 'packages/modules/src/modules/Instructions/Instructions.mdx'
    ),
  'packages/modules/src/modules/Padding/Padding.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-padding-padding" */ 'packages/modules/src/modules/Padding/Padding.mdx'
    ),
  'packages/modules/src/modules/Progress/Progress.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-progress-progress" */ 'packages/modules/src/modules/Progress/Progress.mdx'
    ),
  'packages/modules/src/modules/RegionSelect/RegionMultiselect.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-region-select-region-multiselect" */ 'packages/modules/src/modules/RegionSelect/RegionMultiselect.mdx'
    ),
  'packages/modules/src/modules/RegionSelect/RegionSelect.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-region-select-region-select" */ 'packages/modules/src/modules/RegionSelect/RegionSelect.mdx'
    ),
  'packages/modules/src/modules/RichText/RirchText.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-rich-text-rirch-text" */ 'packages/modules/src/modules/RichText/RirchText.mdx'
    ),
  'packages/modules/src/modules/Section/Section.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-section-section" */ 'packages/modules/src/modules/Section/Section.mdx'
    ),
  'packages/modules/src/modules/Select/Multiselect.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-select-multiselect" */ 'packages/modules/src/modules/Select/Multiselect.mdx'
    ),
  'packages/modules/src/modules/Select/Select.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-select-select" */ 'packages/modules/src/modules/Select/Select.mdx'
    ),
  'packages/modules/src/modules/Slider/Slider.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-slider-slider" */ 'packages/modules/src/modules/Slider/Slider.mdx'
    ),
  'packages/modules/src/modules/Submit/Submit.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-submit-submit" */ 'packages/modules/src/modules/Submit/Submit.mdx'
    ),
  'packages/modules/src/modules/TagVideo/MultipleTagVideo.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-tag-video-multiple-tag-video" */ 'packages/modules/src/modules/TagVideo/MultipleTagVideo.mdx'
    ),
  'packages/modules/src/modules/TagVideo/TagVideo.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-tag-video-tag-video" */ 'packages/modules/src/modules/TagVideo/TagVideo.mdx'
    ),
  'packages/modules/src/modules/Text/Text.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-text-text" */ 'packages/modules/src/modules/Text/Text.mdx'
    ),
  'packages/modules/src/modules/UploadFile/UploadFile.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-upload-file-upload-file" */ 'packages/modules/src/modules/UploadFile/UploadFile.mdx'
    ),
  'packages/modules/src/modules/Video/Video.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-video-video" */ 'packages/modules/src/modules/Video/Video.mdx'
    ),
  'packages/modules/src/modules/YesNo/YesNo.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-yes-no-yes-no" */ 'packages/modules/src/modules/YesNo/YesNo.mdx'
    ),
  'packages/components/src/components/app/Footer/Footer.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-app-footer-footer" */ 'packages/components/src/components/app/Footer/Footer.mdx'
    ),
  'packages/components/src/components/app/JobLogo/JobLogo.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-app-job-logo-job-logo" */ 'packages/components/src/components/app/JobLogo/JobLogo.mdx'
    ),
  'packages/components/src/components/app/ListNav/ListNav.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-app-list-nav-list-nav" */ 'packages/components/src/components/app/ListNav/ListNav.mdx'
    ),
  'packages/components/src/components/app/Navbar/Navbar.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-app-navbar-navbar" */ 'packages/components/src/components/app/Navbar/Navbar.mdx'
    ),
  'packages/components/src/components/app/Notifications/Notification.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-app-notifications-notification" */ 'packages/components/src/components/app/Notifications/Notification.mdx'
    ),
  'packages/components/src/components/app/Upload/Upload.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-components-src-components-app-upload-upload" */ 'packages/components/src/components/app/Upload/Upload.mdx'
    ),
  'packages/modules/src/modules/Wizard/Wizard.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-modules-src-modules-wizard-wizard" */ 'packages/modules/src/modules/Wizard/Wizard.mdx'
    ),
}
